//制造商
import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

import ManuFactPage from "@/views/model/manufacturer/ManuFactPage"; //制造商
// import ManuFactTitleBlock from '@/views/model/manufacturer/ManuFactTitleBlock.vue' //制造商
import ManuFactWhereUsed from "@/views/model/manufacturer/ManuFactWhereUsed.vue"; //制造商
import ManuFactHistory from "@/views/model/manufacturer/ManuFactHistory.vue"; //制造商

export const MFR = {
  path: "/ManuFactPage",
  component: ManuFactPage,
  children: [
    {
      path: "/ManuFactRelationship",
      component: Relationship,
    },
    {
      path: "/ManuFactTitleBlock",
      // name: 'ManuFactTitleBlock',
      component: PageInfo,
    },
    {
      path: "/ManuFactAttachment",
      name: "ManuFactAttachment",
      component: ItemAttachment,
    },
    {
      path: "/ManuFactAttachment2",
      name: "ManuFactAttachment2",
      component: ItemAttachment,
    },
    {
      path: "/ManuFactWhereUsed",
      component: ManuFactWhereUsed,
    },
    {
      path: "/ManuFactHistory",
      component: ManuFactHistory,
    },
  ],
};
